// General
import PropTypes from 'prop-types';
import React, { Component } from 'react';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ListPlaceStep1.css';

// Router
import history from '../../core/history';

// Assets
import logoPrimary from '/public/eslipin-logo-secundario-blue.png';
import stepListIllustration from '/public/SiteImages/step-list.svg';

// Link
import Link from '../Link/Link';

class ListingComplete extends Component {

  static propTypes = {
    listId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  handleGoToListing = () => {
    const { listId } = this.props;
    if (listId) {
      history.push(`/rooms/${listId}/preview`);
    } else {
      history.push('/rooms');
    }
  };

  render() {
    return (
      <div className={s.eslipinBgIntro}>
        {/* Top-left brand logo and slogan */}
        <Link to={'/'} >
          <img src={logoPrimary} className={s.eslipinLogoTop} alt="eslipin" />
          <span className={s.labelLogo}>Alójate seguro, sin complicaciones</span>
        </Link>

        {/* Centered Confirmation Card */}
        <div className={s.completeCardWrapper}>
          <div className={s.completeCard}>
            {/* Mascot Illustration */}
            <div className={s.completeIllustrationWrapper}>
              <img
                src={stepListIllustration}
                className={s.completeIllustration}
                alt="¡Listo!"
              />
            </div>

            {/* Title */}
            <h1 className={s.completeTitle}>¡Listo!</h1>

            {/* Subtitle description */}
            <p className={s.completeSubtitle}>
              Tu alojamiento ya está configurado en Eslipin.<br />
              Ahora los huéspedes podrán conocerlo y enviarte solicitudes de reserva.
            </p>

            {/* Primary Action Button */}
            <button
              type="button"
              className={s.completeBtn}
              onClick={this.handleGoToListing}
            >
              Ir a mi alojamiento
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state, ownProps) => ({
  listId: ownProps.listId || state.location?.listId || state.form?.ListPlaceStep3?.values?.id || state.account?.data?.listId || null,
});

const mapDispatch = {};

export default withStyles(s)(connect(mapState, mapDispatch)(ListingComplete));
